module.exports = __webpack_public_path__ + "img/sh-img1.d754bc1f.png";